module.exports = __webpack_public_path__ + "static/media/header.10046d1f.png";